const bespoke = require("bespoke");

import $ from 'jquery';

console.log('Init bespoke');
let plugins = [
  require("bespoke-auto-play")(),
  require("bespoke-backdrop")(),
  require("bespoke-classes")(),
  //require("bespoke-convenient")(),
  require("bespoke-hash")(),
  require("bespoke-jumpy")(),
  require("bespoke-keys")(),
  require("bespoke-progress")(),
  require("bespoke-scale")(),
  require("bespoke-slidenumber")(),
  require("bespoke-theme-voltaire")(),
  require("bespoke-touch")(),
];

const urlParams = new URLSearchParams(window.location.search);
const autoPlay = urlParams.has('auto');
const _autoplay = require("bespoke-auto-play");
if (autoPlay)
  plugins.push(_autoplay());

// Mouse scroll
const _deck = bespoke.from('article', plugins);
_deck.parent.addEventListener("DOMMouseScroll", function(e) {
  if (e.detail > 0)
    _deck.next();
  if (e.detail < 0)
    _deck.prev();
  e.preventDefault();
});
